import { registerAuditLabels, type StatusMap } from "@vixio/ui";
import { KIND_LABELS, type MediaKind } from "@vixio/media/youtube";

/** Tipos das linhas e RPCs do módulo media (ver modules/media/README.md). */

export type { MediaKind };
export const KIND_LABEL: Record<MediaKind, string> = Object.fromEntries(
  Object.entries(KIND_LABELS).map(([k, v]) => [k, v.one]),
) as Record<MediaKind, string>;

export const ITEM_STATUS: StatusMap = {
  draft: { label: "rascunho", tone: "neutral" },
  published: { label: "publicado", tone: "ok" },
  archived: { label: "arquivado", tone: "warn" },
};

export interface MediaItem {
  id: string;
  org_id: string;
  kind: MediaKind;
  url: string;
  youtube_id: string | null;
  title: string;
  outlet: string | null;
  happened_on: string | null;
  duration_seconds: number | null;
  summary: string | null;
  topics: string[];
  topic_labels: string[];
  featured: boolean;
  position: number;
  thumbnail_url: string | null;
  status: "draft" | "published" | "archived";
  published_at: string | null;
  first_published_at: string | null;
  created_at: string;
  updated_at: string;
}

export interface MediaTopic { id: string; org_id: string; key: string; label: string; position: number; active: boolean }

declare module "@vixio/data" {
  interface RpcRegistry {
    "media.upsert_topic": { args: { p_org: string; p_key: string; p_label: string; p_position?: number; p_active?: boolean }; returns: string };
    "media.upsert_item": {
      args: {
        p_org: string;
        p_kind: MediaKind;
        p_url: string;
        p_title: string;
        p_outlet?: string | null;
        p_happened_on?: string | null;
        p_duration_seconds?: number | null;
        p_summary?: string | null;
        p_topics?: string[];
        p_featured?: boolean;
        p_position?: number | null;
        p_thumbnail_url?: string | null;
        p_id?: string | null;
      };
      returns: string;
    };
    "media.publish_item": { args: { p_item: string }; returns: string };
    "media.unpublish_item": { args: { p_item: string }; returns: string };
    "media.archive_item": { args: { p_item: string }; returns: string };
    "media.delete_item": { args: { p_item: string }; returns: null };
    "media.set_featured": { args: { p_item: string; p_featured: boolean }; returns: null };
    "media.reorder": { args: { p_org: string; p_ids: string[] }; returns: number };
  }
}

registerAuditLabels({
  "media_topic.upserted": "Tema de mídia salvo",
  "media_item.upserted": "Item de mídia salvo",
  "media_item.published": "Item de mídia publicado",
  "media_item.unpublished": "Item de mídia despublicado",
  "media_item.archived": "Item de mídia arquivado",
  "media_item.deleted": "Item de mídia apagado",
  "media_item.featured": "Destaque de mídia alterado",
  "media_item.reordered": "Ordem da mídia alterada",
});
